class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.body = document.querySelector('body');
  }

  onToggle() {
    if (!this.header) return;
    this.updateHeaderClass();
    this.header.preventHide = this.mainDetailsToggle.open;
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );

    }

    updateHeaderClass() {
      if (this.mainDetailsToggle.open) {
          this.body.style.overflow = 'hidden';

          // Create and add overlay
          let overlay = document.createElement('div');
          overlay.id = 'menuOverlay';
          overlay.classList.add('menu-overlay');
          overlay.style.position = 'fixed';
          overlay.style.top = 0;
          overlay.style.left = 0;
          overlay.style.width = '100%';
          overlay.style.height = '100%';
          overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
          overlay.style.display = 'block';
          overlay.style.zIndex = '2';
          this.body.prepend(overlay);
          this.body.classList.add('menu-open');
          this.header.classList.add('solid-header-bg');
      } else {
          this.body.style.overflow = '';

          let overlay = document.getElementById('menuOverlay');
          if (overlay) {
            this.body.removeChild(overlay);
          }

          this.header.classList.remove('solid-header-bg');
          this.body.classList.remove('menu-open');
      }
  }


}

customElements.define('header-menu', HeaderMenu);
